import { endpointConst } from "./cacheLayerConstants";

const burstCacheConfig = {
  // [endpointConst.getEarliestDeliveryDays]: [endpointConst.productList],
};

const cmsConfig = {
  [endpointConst.ctDisabledEvents]: true,
  [endpointConst.nudgeCityList]: true,
  [endpointConst.getIntDeliveryForRakhi]: true,
  [endpointConst.dynamicSearchPlaceholder]: true,
  default: false,
};

const cacheConfig = {
  [endpointConst.geojs]: {
    ttl: 1200000, // 20 minutes
  },
  [endpointConst.ctDisabledEvents]: {
    ttl: 3600000, // 1 hour
  },
  [endpointConst.nudgeCityList]: {
    ttl: 604800000, // 7 days
  },
  [endpointConst.getIntDeliveryForRakhi]: {
    ttl: 900000, // 15 minutes
  },
  [endpointConst.dynamicSearchPlaceholder]: {
    ttl: 3600000, // 1 hour
  },
  default: {
    ttl: 900000,
  },
};

export { burstCacheConfig, cacheConfig, cmsConfig };
